import React, { useState } from "react";
import styles from "./IncomeExpenses.module.css";

function IncomeExpenses({ formData, setFormData }) {
  const [rows, setRows] = useState(
    formData.incomeExpenses || [
      { category: "Base Salary", owner: "Applicant 1", amount: "", frequency: "Annual" },
    ]
  );

  const addRow = () => {
    const updated = [
      ...rows,
      { category: "", owner: "", amount: "", frequency: "Annual" },
    ];
    setRows(updated);
    setFormData({ ...formData, incomeExpenses: updated });
  };

  const removeRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
    setFormData({ ...formData, incomeExpenses: updated });
  };

  const updateRow = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
    setFormData({ ...formData, incomeExpenses: updated });
  };

  return (
    <div className={styles.container}>
      <h3>Income & Expenses</h3>

      <div className={styles.tableHeader}>
        <span>Category</span>
        <span>Owner</span>
        <span>Amount</span>
        <span>Frequency</span>
        <span></span>
      </div>

      {rows.map((row, index) => (
        <div key={index} className={styles.row}>
          {/* Category */}
          <select
            value={row.category}
            onChange={(e) => updateRow(index, "category", e.target.value)}
          >
            <option value="">Select Category</option>
            <option value="Base Salary">Base Salary</option>
            <option value="Bonus">Bonus</option>
            <option value="Overtime">Overtime</option>
            <option value="Rental Income">Rental Income</option>
            <option value="Other">Other</option>
          </select>

          {/* Owner */}
          <select
            value={row.owner}
            onChange={(e) => updateRow(index, "owner", e.target.value)}
          >
            <option value="">Select Owner</option>
            <option value="Applicant 1">Applicant 1</option>
            <option value="Applicant 2">Applicant 2</option>
          </select>

          {/* Amount */}
          <input
            type="number"
            placeholder="$"
            value={row.amount}
            onChange={(e) => updateRow(index, "amount", e.target.value)}
          />

          {/* Frequency */}
          <select
            value={row.frequency}
            onChange={(e) => updateRow(index, "frequency", e.target.value)}
          >
            <option value="Weekly">Weekly</option>
            <option value="Fortnightly">Fortnightly</option>
            <option value="Monthly">Monthly</option>
            <option value="Annual">Annual</option>
          </select>

          {/* Remove */}
          <button
            className={styles.removeBtn}
            onClick={() => removeRow(index)}
          >
            ×
          </button>
        </div>
      ))}

      <button className={styles.addBtn} onClick={addRow}>
        + Add Income/Expense
      </button>
    </div>
  );
}

export default IncomeExpenses;
